import React, { useState } from 'react'
import { useDrag } from 'react-dnd'
import { FormGroup, Label, Button } from 'reactstrap'

import Settings from './Settings'
import { FieldType } from '../../FieldTypes'

const Programs = ({
  field,
  removeFunc,
  setFieldOrderFunc,
  updateCurrentSetting,
  setFieldSettingsModalOpen,
  updateFieldSettings
}) => {
  const [isMouseIn, setIsMouseIn] = useState(false)

  // draggable
  const [{ isDragging }, draggable] = useDrag({
    item: { id: field.id, parentId: field.fieldGroupId, type: FieldType.PROGRAMS },
    type: FieldType.PROGRAMS,
    collect: monitor => {
      return {
        isDragging: !!monitor.isDragging()
      }
    }
  })

  return (
    <div
      ref={draggable}
      style={{
        border: isMouseIn || isDragging ? '1px dashed black' : 'none',
        cursor: 'move',
        backgroundColor: isDragging ? 'lightblue' : 'white',
        width: '100%',
        display: 'inline-block'
      }}
    >
      <FormGroup
        onMouseEnter={() => {
          setIsMouseIn(true)
        }}
        onMouseLeave={() => {
          setIsMouseIn(false)
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Label>
            {field.required ? '* ' : ''}
            {field.displayName}
          </Label>
          <div style={{ display: 'flex' }}>
            <Button
              size='xs'
              color='primary'
              title='Settings'
              onClick={() => {
                updateCurrentSetting(
                  <Settings
                    field={field}
                    setFieldOrderFunc={setFieldOrderFunc}
                    updateFieldSettings={updateFieldSettings}
                  />
                )
                setFieldSettingsModalOpen(true)
              }}
            >
              <i className='fas fa-tools' />
            </Button>
            <Button
              size='xs'
              color='danger'
              title='Remove'
              onClick={() => {
                removeFunc(field.id)
              }}
            >
              <i className='fas fa-times' />
            </Button>
          </div>
        </div>
        <select className='form-control' disabled>
          <option>Summer Camp</option>
          <option>After school party</option>
          <option>Soccer Training</option>
        </select>
        <span>{field.instructions}</span>
      </FormGroup>
    </div>
  )
}

export default Programs
